import { render, staticRenderFns } from "./sharding.vue?vue&type=template&id=5b68e8b0&scoped=true&"
import script from "./sharding.vue?vue&type=script&lang=js&"
export * from "./sharding.vue?vue&type=script&lang=js&"
import style0 from "./sharding.vue?vue&type=style&index=0&id=5b68e8b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b68e8b0",
  null
  
)

export default component.exports